module.exports = __webpack_public_path__ + "static/media/Retrusion of the anterior teeth5.7f0a68f8.png";